import './SmsMulti_table.scss';
import * as S from '../scss/theme';
import React, { useState, useEffect, useRef } from "react";
import fnc from '../mymod/commFunction';

import { useDispatch, useSelector } from 'react-redux';
import { } from '../reduxToolkit/redux';

import { Checkbox } from '@mui/material';

const SmsMulti_table = ({list_sms, setList_sms}) => {

    const [isSelectAll, setIsSelectAll] = useState(false);
    const [list, setList] = useState([]);
  
    useEffect(() => {
      setList(list_sms);
    }, [list_sms]);

    
   //---------------------------checkbox
   function handleCheckboxChange(event, index) {
    const isChecked = event.target.checked;

    const newList = [...list];
    newList[index].isChecked = isChecked;
    setList(newList);
    setList_sms(newList);

 
  // 모두 체크되었는지 확인하여 헤더 체크박스 상태 업데이트
  const allChecked = newList.every(item => item.isChecked);
  setIsSelectAll(allChecked);
  }

  function handleSelectAllChange() {
    const newList = list.map(item => ({...item, isChecked: !isSelectAll }));
    setList(newList);
    setList_sms(newList);
    setIsSelectAll(!isSelectAll);
  }//checkbox END


  //=========================================
    return (

      <div className="SmsMulti_table">       
        <div className="wrap-main">
          <section className="section-main">
            <table className="table-hong table-main">
              <thead>
                <tr>
                    <th>No</th>
                    <th>
                      <Checkbox    
                          className="custom-checkbox"
                          checked={isSelectAll}
                          onChange={handleSelectAllChange} 
                      />

                    </th>
                    <th>성명</th>
                    <th>HP학생</th>
                    <th>HP부모</th>
                    <th>내용</th> 
                    <th>Byte</th> 
                </tr>
              </thead>

              <tbody>
                  {list && list.map((item, index) => (
  
                      <tr key={index}>  
                        <td>{index+1}</td>
                        <td>
                          <Checkbox
                            className="custom-checkbox"
                            checked={item.isChecked}
                            onChange={(event) => handleCheckboxChange(event, index)} />
                        </td>
                        <td>{item.name}</td>
                        <td>{item.hp}</td>
                        <td>{item.hp_parent}</td>
                        <td>{item.content}</td>
                        <td>{item.byte}</td>
                        {/* <td>{item.stCode}</td> */}

                      </tr>
                  ))}
            
                </tbody>
            </table>
          </section>
        </div>
      </div>
    );

   
}

export default SmsMulti_table;